module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAMAAADzN3VRAAAAAXNSR0IB2cksfwAAAEJQTFRFAAAAKXn/Knj/KXn/KXn/KXn/Knf/KHr/KHn/KHj/KXn/Knr/KHn/KHj/KXn/KXn/KXn/KXn/KXn/MID/KXj/KHj/qEjy0QAAABZ0Uk5TAFCfv+//T2BfIM8w0EDw36DA4BCQf6CRjTYAAADHSURBVHicdZLhFoMgCIW1cK50htbe/1UnKGSdxg8VPxG4akw3O83gYJ5e5moenBi8h/1ldaOti4AA7moQesQdVNSiovjBfPRCTq4nq6NrX530SLbah3skzhr8Q9BkmgoOBAuNmdPEnetoxJudqgU+dbQSmdD64BtS64QQEawDd5VaHpaDWkAVK/faRKlTRZR+FIm8VjXoSEAZdGOkD+JHrStSENv7iKbwFZD6q4ZT7g600iVeQNR/QGWcYcXf/pXFnFzKaGXjB5KFCyH80xkcAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./app/images/download.png
// module id = 1311
// module chunks = 0